import NavBar from "./NavBar.js"; 
import Product from "./Product.js"; 
import { useState, useEffect} from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom"; 
import axios from "axios";  
import { Helmet } from "react-helmet";
function Preview() {
    
    const location = useLocation();
    const navigate = useNavigate();

    const { ID } = useParams();

    const [productDetails, setProduct] = useState([{}]);    
    const [imageurl, setimageUrl] = useState('');    
    const [error, setError] = useState("");
    
    const product = { "code": 200, "status": "Success!", "message": { "cuisine": { "meal_type": [{ "id": 10, "type": "Lunch" }, { "id": 12, "type": "Dinner" }], "cuisine": [{ "id": 3, "type": "Indian" }], "dietery": [], "sizes": [{ "id": 3, "size": "Medium" }, { "id": 4, "size": "Large" }], "ingredients": "boneless & skinless chicken, yogurt, ginger, garlic, garam masala, turmeric, ground cumin, kashmiri chilli, ground corriander, ground red chilli power, cream, salt, cilantro, vegetable oil, butter, onion, tomato", "allergens": [{ "id": 5, "allergen": "Milk" }], "nutrients": [{ "total_calories": "800cal", "total_fat": "50g", "saturated_fat": "20g", "trans_fat": "15g", "cholesterol": "300mg", "sodium": "750mg", "total_carbohydrate": "20g", "dietary_fiber": "5g", "sugars": "150g", "protein": null }] }, "chef": { "name": "Nalan Doe", "age": 45, "country": "India", "bio": "Experienced and talented Indian chef skilled in the preparation and serving of Asian foods. Adheres to standards in cooking. Capable of giving every meal an exciting and unique spin that always impresses.", "images": "https://global-uploads.webflow.com/61154a627733993096a9a3af/618ae06883ad82a13f292916_dl.png", "video": "https://www.youtube.com/watch?v=E9bSLVgw0qI" }, "customer": { "name": "Madras Chettinad", "active": true, "subscription_end_date": "2023-03-01T00:00:00.000Z", "address_1": "123 Main Street", "city": "Alpharretta", "state": "GA", "country": "USA", "logo": "http://1.bp.blogspot.com/-52DP34Lcn94/Tj9HXb1ay7I/AAAAAAAAA-A/tB1zRIRftK8/s320/Restaurant-18894-Madras-Chettinaad-68324.jpg" }, "name": "Chicken Tikka Masala", "title1": "chicken tikka masala", "title2": "chicken thighs or breasts", "desc1": "The BEST part about this recipe and just like our Butter Chicken � you may already have these ingredients in your kitchen. If not, they are so easy to find in any grocery store, you won�t need to go searching high and low to find them! Authentic Chicken Tikka Masala is usually made with yogurt marinated chicken, skewered and chargrilled for incredible bbq flavours. For the sake of making this recipe much easier for us to make at home, we are using a skillet or pot to cook it all in, while still keeping those amazing flavours.", "desc2": "We are still coating and marinating our chicken with an aromatic spiced Tikka yogurt, using chicken thighs instead of breasts for juicy and succulent results. Using thighs also cuts down on marinating time, needing only a minimum of 10 minutes to soak all of those flavours in!", "images": "https://cafedelites.com/wp-content/uploads/2018/04/Chicken-Tikka-Masala-IMAGE-22.jpg,https://cafedelites.com/wp-content/uploads/2018/04/Best-Chicken-Tikka-Masala-IMAGE-2.jpg,https://media.istockphoto.com/photos/chicken-tikka-indian-food-picture-id1150376652,https://media.istockphoto.com/photos/kebab-grilled-chicken-meat-and-vegetables-picture-id1068906264,https://media.istockphoto.com/photos/roasted-chicken-wings-served-on-a-white-plate-with-peppers-onions-picture-id1178859373", "video": "https://www.youtube.com/watch?v=BOKdsepCrbc", "date_created": "2022-03-20T00:00:00.000Z", "date_expired": "2023-03-01T00:00:00.000Z", "price": 12.99, "discount_price": 9.99, "discount_percentage": 0, "sale": false, "sale_reason": null, "date_sale_expired": null }, "errors": [] };

    const styleLink = "/css/style.blue.min.css";
    console.log(location.state);
   
    useEffect(() => {
        if (ID) {
            localStorage.removeItem('products');
            fetchProducts();

        }
        else
            navigate("/producterror");
    },[])

   
 
    const fetchProducts = async () => {
        if (!ID) { setError("No data found."); return;}
        const response = await axios(process.env.REACT_APP_API_END_POINT + "product?id=" + ID).catch(e => {            
            setError(e);
            navigate("/producterror");
        });
        if (response.data.errors.length <= 0) {
            // setProduct(product);
            if (response.data.message && response.data.message["customer"]) {
                const expiryDate = new Date(response.data.message["customer"]["subscription_end_date"]);
                if (response.data.message["customer"]["active"] && expiryDate >= new Date()) {
                    setProduct(response.data);
                    const image = response.data.message["images"].split(',');
                    console.log(image);
                    if (image.length > 0)
                        setimageUrl("https://mdbcdn.b-cdn.net/img/Photos/Slides/img%20(22).webp");
                }
                else {
                   navigate("/producterror")
                }
            }
            else {

                setError("No data found");
            }

               
           
        } else { setError(response.data.errors[0]);}
    }

   
   
    return (
        <>
            <Helmet>
                <link rel="stylesheet" href={styleLink} />
                <link rel="stylesheet" href={"/css/custom.css"} />
            </Helmet> 
            <NavBar /> 
            {(error != "") ? <div className="m-5"><div className="alert mb-3 alert-danger" role="alert"> <strong>Error! </strong>{error}</div></div> : ""}
            {(localStorage.getItem('products') && !ID) ? <Product imageurl={imageurl} details={JSON.parse(localStorage.getItem('products'))} />:<>
            {(productDetails && productDetails.message  && error == "") ? <>
                    <Product imageurl={imageurl} details={productDetails.message}/>
           </>:''}</>}
          
       </>
 
  );
}

export default Preview;